'use client';

import { c as _c } from "react/compiler-runtime";
import { canAuthorizeWithdrawal } from '@morfi/onramp-sdk';
import type { useWithdrawalCheckout } from '@morfi/onramp-sdk/react';
import { useTranslations } from 'next-intl';
import type { ReactNode } from 'react';
import { AnimatedButton } from '@/components/ui/animated-button';
import { WithdrawalReceiptContent } from '../history/funding-receipt';
import { SellProviderFrame } from './sell-provider-frame';
type Flow = ReturnType<typeof useWithdrawalCheckout>;
type Command = Parameters<Flow['commands']['mutateAsync']>[0];
type OperationFlow = Pick<Flow, 'hostedUrl' | 'resumeError' | 'canReport' | 'finish' | 'screen'> & {
  operation: Pick<Flow['operation'], 'data' | 'isError' | 'isFetching'>;
  commands: Pick<Flow['commands'], 'isPending' | 'isError'>;
};
export function WithdrawOperationScreen(t0) {
  const $ = _c(23);
  const {
    flow,
    expired,
    retryRequest,
    run,
    send,
    onClose
  } = t0;
  const t = useTranslations("onramp");
  const operation = flow.operation.data;
  const evidence = operation?.withdrawal;
  let t1;
  if ($[0] !== evidence?.recipient || $[1] !== evidence?.sendReserved || $[2] !== flow.hostedUrl || $[3] !== flow.screen || $[4] !== operation?.status) {
    t1 = flow.hostedUrl && (flow.screen === "payout_account" || flow.screen === "hosted") && (operation?.status === "action_required" || !(evidence?.recipient || evidence?.sendReserved || ["delivered", "failed", "cancelled", "refunded"].includes(operation?.status ?? "")));
    $[0] = evidence?.recipient;
    $[1] = evidence?.sendReserved;
    $[2] = flow.hostedUrl;
    $[3] = flow.screen;
    $[4] = operation?.status;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const hostedVisible = Boolean(t1);
  let t2;
  if ($[6] !== flow.hostedUrl || $[7] !== hostedVisible) {
    t2 = flow.hostedUrl ? <div hidden={!hostedVisible}><SellProviderFrame url={flow.hostedUrl} /></div> : null;
    $[6] = flow.hostedUrl;
    $[7] = hostedVisible;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== evidence || $[10] !== expired || $[11] !== flow || $[12] !== hostedVisible || $[13] !== onClose || $[14] !== operation || $[15] !== retryRequest || $[16] !== run || $[17] !== send || $[18] !== t) {
    t3 = operation && !hostedVisible && flow.screen !== "payouts" ? <><WithdrawalReceiptContent operation={operation} />{evidence?.kind === "sell" && operation.status === "created" && !evidence?.sendReserved && !evidence?.recipient ? <AnimatedButton onClick={() => run({
        kind: "create"
      })}>{t("continue")}</AnimatedButton> : null}{(flow.operation.isError || flow.resumeError) && !flow.canReport && !canAuthorizeWithdrawal(operation.status, evidence) ? <AnimatedButton loading={flow.operation.isFetching} onClick={retryRequest}>{t(expired ? "sign_in" : "retry")}</AnimatedButton> : null}{flow.canReport ? <AnimatedButton loading={flow.commands.isPending} disabled={flow.commands.isPending} onClick={() => run({
        kind: "report"
      })}>{t("retry")}</AnimatedButton> : null}{canAuthorizeWithdrawal(operation.status, evidence) ? <AnimatedButton loading={flow.commands.isPending} disabled={flow.commands.isPending} onClick={() => flow.operation.isError ? retryRequest() : run({
        kind: "send",
        send
      })}>{expired ? t("sign_in") : flow.commands.isError || flow.operation.isError ? t("retry") : t("withdraw_send")}</AnimatedButton> : null}{!evidence?.sendReserved && ["created", "awaiting_payment"].includes(operation.status) ? <AnimatedButton variant="tertiary" onClick={() => run({
        kind: "cancel"
      })}>{t("cancel")}</AnimatedButton> : null}{["delivered", "failed", "cancelled", "refunded"].includes(operation.status) ? <AnimatedButton onClick={() => {
        flow.finish();
        onClose();
      }}>{t("done")}</AnimatedButton> : null}</> : null;
    $[9] = evidence;
    $[10] = expired;
    $[11] = flow;
    $[12] = hostedVisible;
    $[13] = onClose;
    $[14] = operation;
    $[15] = retryRequest;
    $[16] = run;
    $[17] = send;
    $[18] = t;
    $[19] = t3;
  } else {
    t3 = $[19];
  }
  let t4;
  if ($[20] !== t2 || $[21] !== t3) {
    t4 = <>{t2}{t3}</>;
    $[20] = t2;
    $[21] = t3;
    $[22] = t4;
  } else {
    t4 = $[22];
  }
  return t4;
}